const createLink = (view, href) => view.state.schema.marks.link.create({
  href,
});

const createHeaderTemplate = (view, name, mark) =>
    view.state.schema.nodes.table_header.create({}, [
      view.state.schema.nodes.paragraph.create({},
          view.state.schema.text(name, mark)),
    ]);

const createCellTemplate = (view, name, mark) =>
    view.state.schema.nodes.table_cell.create({}, [
      view.state.schema.nodes.paragraph.create({},
          view.state.schema.text(name, mark)),
    ]);

export const tasksTableNodes = view => view.state.schema.nodes.table.create({
  sort: 'swf:createdOn',
  desc: '1',
}, [
  view.state.schema.nodes.table_row.create({}, [
    createHeaderTemplate(view, 'Key'),
    createHeaderTemplate(view, 'Summary', createLink(view, '?sort=summary')),
    createHeaderTemplate(view, 'Status', createLink(view, '?sort=status')),
    createHeaderTemplate(view, 'Type', createLink(view, '?sort=type')),
    createHeaderTemplate(view, 'Priority', createLink(view, '?sort=priority')),
    createHeaderTemplate(view, 'Created on',
        createLink(view, '?sort=swf:createdOn')),
    createHeaderTemplate(view, 'Created by'),
  ]),
  view.state.schema.nodes.table_row.create({}, [
    createCellTemplate(view, '${key}', createLink(view, '${swf:taskUrl}')),
    createCellTemplate(view, '${summary}'),
    createCellTemplate(view, '${status}'),
    createCellTemplate(view, '${type}'),
    createCellTemplate(view, '${priority}'),
    createCellTemplate(view, '${swf:createdOn}',
        view.state.schema.marks.relative_time.create({
          datetime: '${swf:createdOn}'
        })),
    createCellTemplate(view, '${swf:createdBy.fullName}',
        createLink(view, '/people/${swf:createdBy.id}')),
  ]),
]);